import { AGE_ROLEPLAY_OPTIONS } from '../AGE_ROLEPLAY_OPTIONS';
import { AgeRoleplayOptionIdType } from '../types';

const DEFAULT: AgeRoleplayOptionIdType = 'young';

export const getAgeRoleplayIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): AgeRoleplayOptionIdType | null => {
  const id = AGE_ROLEPLAY_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT;
  }

  return null;
};
